import React from 'react';
import ProgressBar from "../ProgressBar.tsx";
import {TabPanel} from "@chakra-ui/react";
import {IItemProgress} from "../../models/interfaces/itemProgress.interface.ts";
import {IStateEnum} from "../../models/enums/state.enum.ts";
import {useProject} from "../../hooks/useProject.ts";
import SmartIcon from "../SmartIcon.tsx";
import {IoReload} from "react-icons/io5";
import {useProjectsStore} from "../../store/useProjectsStore.ts";
import {downloadFeatures} from "../../services/projectService.ts";

interface SingleFeatureProgressProps {
  projectId: string;
  projectName: string;
  feature?: IItemProgress;
  featureName: "dialogueList" | "extendedMetadata";
}

const SingleFeatureProgress: React.FC<SingleFeatureProgressProps> = (
  {
    projectId,
    projectName,
    feature,
    featureName
  }: SingleFeatureProgressProps) => {
  const {resetFeature} = useProjectsStore();
  const {getItemStateEnum} = useProject();

  const downloadLanguageFeature = async () => {
    const info: {
      subtitles?: string[],
      audioDescriptions?: string[],
      dialogueList?: boolean,
      extendedMetadata?: boolean,
    } = {}
    info[featureName] = true
    downloadFeatures(projectId,projectName, info).catch(console.error);
  }

  const resetLanguageFeature = async () => {
    await resetFeature(projectId, featureName);
  }


  if (!feature) {
    return null;
  }

  const targetLanguageState: IStateEnum = getItemStateEnum(feature)

  return (
    <TabPanel>
      <div className="flex items-center gap-4">
        <ProgressBar percentage={feature!.pct}/>
        {targetLanguageState == IStateEnum.FAILED && (
          <div className="text-red-500 text-sm mt-4 gap-4">
            <div onClick={resetLanguageFeature}>
              <SmartIcon
                name={IoReload}
                fill="#fff"
                className="w-4 h-4 cursor-pointer"
              />
            </div>
          </div>
        )
        }
        {targetLanguageState == IStateEnum.DONE && (
          <div className="mt-4" onClick={downloadLanguageFeature}>
            <SmartIcon
              name={"download"}
              fill="#fff"
              className="w-5 h-5 cursor-pointer"
            />
          </div>
        )
        }
      </div>
    </TabPanel>

  )
}

export default SingleFeatureProgress;